import { Injectable } from '@angular/core';
import { BaseAPIClass } from '@app/core/class/baseAPI.class';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Registro } from '@core/model/registro.model';

@Injectable({
  providedIn: 'root'
})
export class RegistroService extends BaseAPIClass {
  constructor(protected httpClient: HttpClient) {
    super(httpClient);
    this.baseUrl = '/registros';
  }

  finalizar(data: any): Observable<any> {
    return this.httpClient.post(this.baseUrl + '/finalizar', data);
  }

  habilitar(habitacion_id: number): Observable<any> {
    return this.httpClient.get(this.baseUrl + `/habilitar/${habitacion_id}`);
  }

  getAll(filterObject?: any) {
    return super
      .getAll(filterObject)
      .pipe()
      .pipe(
        map(res => {
          // console.log('pipe', data);
          /*    data.data.map((res: Registro) => {
            // console.log(res);
            let registro: Registro;
            registro = res;
            return registro;
          });*/
          const registros: Registro[] = res.data;

          return { ...res, registros };
        })
      );
  }

  registerServicio(data: any): Observable<any> {
    return this.httpClient.post(this.baseUrl + '/servicios', data);
  }

  getByIdServicio(id: any): Observable<any> {
    return this.httpClient.get(this.baseUrl + '/servicios/' + id);
  }

  deleteByIdServicio(id: any): Observable<any> {
    return this.httpClient.delete(this.baseUrl + '/servicios/' + id);
  }

  aumentarDias(data: any): Observable<any> {
    return this.httpClient.post(this.baseUrl + `/aumentar`, data);
  }

  editAumentarDias(data: any): Observable<any> {
    return this.httpClient.post(this.baseUrl + `/editar`, data);
  }

  listAumentarDias(idRegistro: any): Observable<any> {
    return this.httpClient.get(
      this.baseUrl + `/listar_servicios_alquiler/${idRegistro}`
    );
  }
}
